import styled from 'styled-components';

const motionEase = 'cubic-bezier(0.22, 1, 0.36, 1)';
export const LAYOUT_ALERT_MOTION_MS = 320;

/**
 * Height via 0fr → 1fr so the strip can collapse without a fixed max-height.
 * Opacity / slide live on the child so the clip can stay overflow:hidden.
 */
export const Motion = styled.div<{ $open: boolean }>`
  display: grid;
  grid-template-rows: ${({ $open }) => ($open ? '1fr' : '0fr')};
  width: 100%;
  flex-shrink: 0;
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
  transition: grid-template-rows ${LAYOUT_ALERT_MOTION_MS}ms ${motionEase};
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const MotionClip = styled.div<{ $open: boolean }>`
  overflow: hidden;
  min-height: 0;
  > * {
    opacity: ${({ $open }) => ($open ? 1 : 0)};
    transform: ${({ $open }) => ($open ? 'translateY(0)' : 'translateY(-10px)')};
    transition:
      opacity 260ms ${motionEase},
      transform ${LAYOUT_ALERT_MOTION_MS}ms ${motionEase};
  }
  @media (prefers-reduced-motion: reduce) {
    > * {
      transition: none;
    }
  }
`;
